<template>
  <form>
    <div class="image-container mb-3" v-if="previewPath">
      <img :src="previewPath" alt="Uploaded Image Preview" />
    </div>
    <div class="form-group">
      <div ref="dashboardContainer"></div>
    </div>
    <!-- <v-btn :disabled="disabled" @click.prevent="confirmUpload" class="btn btn-primary btn-block mb-2">Confirm upload</v-btn> -->
  </form>
</template>

<script>
import Uppy from "@uppy/core";
// import XHRUpload from "@uppy/xhr-upload";
import AwsS3Multipart from "@uppy/aws-s3-multipart";
import { guardMultipartAbort } from "@/utils/uppyS3Multipart";

import Dashboard from "@uppy/dashboard";
// import Form from "@uppy/form";
import Russian from "@uppy/locales/lib/ru_RU";
import English from "@uppy/locales/lib/en_US";
import { s3PublicUrl } from "@/utils/s3PublicUrl";

import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";

export default {
  props: {
    maxFileSizeInBytes: {
      type: Number,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      payload: null,
      previewPath: null,
      disabled: true,
      isLoading: false,
    };
  },
  mounted() {
    this.instantiateUppy();
  },
  beforeDestroy() {
    this.uppy.close();
  },
  methods: {
    instantiateUppy() {
      let self = this;
      this.uppy = new Uppy({
        debug: true,
        locale: this.$i18n.locale === "ru" ? Russian : English,
        autoProceed: true,
        allowMultipleUploads: false,
        restrictions: {
          maxFileSize: this.maxFileSizeInBytes,
          minNumberOfFiles: 1,
          maxNumberOfFiles: 1,
          allowedFileTypes: [
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ],
          // allowedFileTypes: ['image/*', 'application/doc', 'application/docx', 'application/pdf']
        },
      })
        .use(Dashboard, {
          hideUploadButton: true,
          theme: this.theme,
          inline: true,
          width: this.width,
          height: this.height,
          target: this.$refs.dashboardContainer,
          replaceTargetContent: true,
          showProgressDetails: true,
          browserBackButtonClose: true,
          locale: {
            strings: {
              poweredBy2: "",
              // browseFiles: "выберите"
            },
          },
        })
        .use(AwsS3Multipart, {
          limit: 1,
          companionUrl: `${this.$store.getters.getApiUrl}/`, // FT-018
        });
      // Инцидент 2026-08-23/26: отмена загрузки, пока createMultipartUpload
      // ещё в полёте, улетала как DELETE /s3/multipart/null?key=null.
      guardMultipartAbort(this.uppy);

      this.uppy.on("complete", (event) => {
        if (event.successful[0] !== undefined) {
          // this.payload = event.successful[0].response.body.path;
          // const imageName = uuid.v1();
          // let fileExtention = file.name.split(".")[1];
          console.log(event.successful[0].s3Multipart.key);
          this.disabled = false;
          this.axios
            .post(
              `/api/v1/doc_templates`,
              {
                doc_templates: {
                  name: event.successful[0].s3Multipart.key,
                  url: s3PublicUrl(event.successful[0].s3Multipart.key),
                },
              },
              {
                headers: {
                  Authorization: self.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.$store.commit(
                "setDocUrl",
                s3PublicUrl(event.successful[0].s3Multipart.key)
              );
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.error"));
            });
        }
      });

      const uploadedFileData = (file, response) => {
        return JSON.stringify(response.body);
      };
    },
    updatePreviewPath({ path }) {
      this.previewPath = path;

      return this;
    },
    resetUploader() {
      this.uppy.reset();
      this.disabled = true;

      return this;
    },
    confirmUpload() {
      if (this.payload) {
        this.disabled = true;
        this.axios
          .post("/store", { file: this.payload })
          .then(({ data }) => {
            this.updatePreviewPath(data).resetUploader();
            this.$notify("Файлы загружены!", "Вы успешно загрузили файлы!", "success", 5000);
          })
          .catch((err) => {
            console.error(err);

            this.resetUploader();
          });
      } else {
        this.$notify("Ошибка при загрузке!", this.error, "error", 5000);
      }
    },
  },
};
</script>

<style scoped>
.image-container {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: auto;
  margin-left: auto;
}

.image-container>img {
  width: inherit;
  height: inherit;
}
</style>
